import React from "react";
import { Outlet } from "react-router-dom";
import { DashboardProvider } from "./DashboardContext";
import { DashboardControls } from "./components/DashboardControls";
import Page from "../../components/Pages/Page";

export const DashboardLayout: React.FC = () => (
  <DashboardProvider>
    <Page sx={{ maxWidth: "1440px" }}>
      <DashboardControls />
      <Outlet />
    </Page>
  </DashboardProvider>
);
